import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Information = () => (_jsxs("svg", Object.assign({ viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg" }, { children: [_jsx("path", { d: "m37.18 55.25h4.82v6.75h-20v-6.75h5.19v-28.33h-5v-7h15z" }), _jsx("ellipse", { cx: "31.4", cy: "8.18", rx: "6.38", ry: "6.18" })] })));
export default Information;
